import {
  DEFAULT_FPLUS_WIDTH,
  useContainerWidthInFPlusCharacters,
} from '@festina-life/fplus'
import { useEffect, useRef } from 'react'

import { useFPlusFormattedExpressionsContext } from '../../../context/fPlusFormattedExpressionsContext'

/*
 * API hook used for formatting an FPlus expression to a given width on a standard festina component.
 */
export const useFormatFPlusExpression = (code: string, width?: number) => {
  const containerRef = useRef<HTMLElement>(null)
  const fplusContainerWidth = useContainerWidthInFPlusCharacters({
    ref: containerRef,
  })

  const formatWidth = Math.min(
    width ?? fplusContainerWidth ?? DEFAULT_FPLUS_WIDTH,
    DEFAULT_FPLUS_WIDTH,
  )
  const { requestFormat, format } = useFPlusFormattedExpressionsContext()

  useEffect(() => {
    requestFormat({
      width: formatWidth,
      expression: code,
    })
  }, [code, requestFormat, fplusContainerWidth, width, formatWidth])

  return {
    formattedCode: format({
      width: formatWidth,
      expression: code,
    }),
    ref: containerRef,
  }
}
